module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp123_8019.fc383107.png";